<template>
  <v-card class="dt-modal">
    <!-- <div class="dt-modal--header">New Contact</div> -->
    <div class="dt-modal--body new-promoter-add">
      <v-layout row wrap>
        <v-flex md12 class="box-container">
          <div class="box-widget selected">
            <div class="box-header gray">
              <div class="box-header--name">{{ $t("promoter") }}</div>
            </div>
            <div class="box-body promoter-contacts">
              <v-layout row wrap>
                <v-flex md6>
                  <div class="search" v-if="!selectedContact">
                    <InputField
                      :value="searchString"
                      :placeholder="$t('search')"
                      :config="{
                        borderStyle: 'around',
                      }"
                      @keyup="onSearchInputKeyup"
                    ></InputField>
                  </div>
                </v-flex>
              </v-layout>
              <div v-if="!selectedContact" class="dt-page--data-table">
                <NTable 
                  :id="'booking-promoters-add_new'" 
                  :headers="headers" 
                  :items="listItems" 
                  :config="invoiceTableConfig"
                  @scrollnext="onContactScroll" 
                >
                  <template v-slot:item="{ item, tdcon }">
                    <tr>
                      <td v-bind="tdcon('name')" @click="onContactRowClicked(item)" style="cursor: pointer">
                        <span>{{ getName(item) }}</span>
                      </td>
                      <td v-bind="tdcon('city')" >
                        <span>{{ item["city"] }}</span>
                      </td>
                      <td v-bind="tdcon('country')">
                        <span>{{ item["country"] }}</span>
                      </td>
                    </tr>
                  </template>
                </NTable>
              </div>
              <div v-if="selectedContact" class="matched-promoters-container" style="margin: 10px">
                <p>{{ getNameCity(selectedContact) }}</p>
                <v-flex md12 class="box-container">
                  <div class="box-widget selected">
                    <div class="box-header gray">
                      <div class="box-header--name">{{ $t("promoters") }}</div>
                    </div>
                    <div class="box-body" style="overflow-y: auto; height: 70%; text-align: center; min-height: 80px">
                      <button class="dt-button v1" style="width: 90%" @click.stop="linkPromoter(selectedContact.contact_id, item.promoter_id)" :key="item.promoter_id" v-for="item in matchedPromoters">{{ getNameCity(item) }}</button>
                    </div>
                  </div>
                </v-flex>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="dt-modal--options">
      <v-layout row wrap>
        <v-flex md6 class="text-xs-left">
          <button class="dt-button v1" @click.stop="addContactAsNewPromoter(selectedContact.contact_id)" v-if="newPromoterButton">{{ $t("no_matches_continue_here") }}</button>
        </v-flex>

        <v-flex md6 justify-end class="text-xs-right">
          <button class="dt-button" @click.stop="onCancel">{{ $t("cancel") }}</button>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from "../../store";
import * as ActionTypes from "../../store/types";

import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";
import { Subject } from "rxjs";
import { subscribeSubject } from "../../../../utility";

import { mapGetters, mapActions } from "vuex";
import TextField from "@plugins/text-field/text-field";
import InputField from "../../../../plugins/text-field/input-field";
import { bookingPromotersService } from "../../services/booking-promoters.service";

const listLength = 100;

export default {
  props: ["listItems"],
  components: {
    TextField,
    InputField,
    NTable,
  },
  data: function () {
    return {
      invoiceTableConfig: createNTableConfig({
        headerStyle: 1,
        rowHeight: 30,
        // fullHeight: true
      }),
      contactsData: [],
      selectedContact: null,
      matchedPromoters: [],
      newPromoterButton: false,
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },

      startFrom: 0,
      searchSubject$: new Subject(),
      searchString: "",
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      add_promoter_contact_list_start_from: "add_promoter_contact_list_start_from",
    }),
    headers: function () {
      return [
        createTableHeader("name", {fw: 700, c: 'black'}), //
        createTableHeader("city"),
        createTableHeader("country"),
      ];
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
      this.selectedContact = null;
      this.searchString = "";
      this.newPromoterButton = false;
      this.startFrom = 0;
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(this.searchString);
    },
    onClickSend: function () {},
    onContactScroll: function (value) {
      // this.scrollSubject$.next(value);
      // console.log("on scroll..");
      if (this.add_promoter_contact_list_start_from == this.startFrom) {
        // console.log("scroll..");
        this.startFrom += listLength;
        this.$emit("loadMore", this.startFrom);
      } else {
        // console.log("NOT scroll..");
      }
    },
    onContactRowClicked(item) {
      this.matchedPromoters = [];
      this.newPromoterButton = false;
      this.selectedContact = item;
      bookingPromotersService.matchedPromoters(item.contact_id).then((res) => {
        this.matchedPromoters = res.data;
      });
    },
    getName(item) {
      return item.company_name ? item.company_name : item.first_name + " " + item.last_name;
    },

    getNameCity(item) {
      return this.getName(item) + (item.city ? ", " + item.city : "");
    },

    linkPromoter(contact_id, promoter_id) {
      this.onCancel();
      bookingPromotersService.linkPromoter(contact_id, promoter_id).then((res) => {});
      // console.log("contact id", contact_id, "promoter id", promoter_id);
    },

    addContactAsNewPromoter(contact_id) {
      this.onCancel();
      bookingPromotersService.addContactAsNewPromoter(contact_id).then((res) => {});
    },
  },
  mounted: function () {
    subscribeSubject(this, this.searchSubject$, (searchString) => {
      this.$emit("searched", searchString);
    });
  },
  beforeDestroy() {},
  watch: {
    matchedPromoters: function (newVal) {
      this.newPromoterButton = newVal.length > 0 ? false : true;
    },
  },
};
</script>

<style lang="scss" scoped>
.new-promoter-add {
  .promoter-contacts {
    height: 450px !important;
  }
  .dt-ntable {
    --ntable-height: 395px !important;
    /* td:first-child {
      font-weight: 700;
      color: black;
    } */
  }
  .search {
    margin: 10px;
  }
}
</style>